import "./record-chain-mark.css";

/** Значок цепочки записей на блоке расписания. */
const RecordChainMark = ({ linkId, variant = "onDark", onClick, showLabel = false }) => {
  if (!linkId) return null;

  const label = `Цепочка #${linkId}`;
  const className = [
    "record-chain-mark",
    `record-chain-mark--${variant}`,
    onClick ? "record-chain-mark--clickable" : "",
  ].filter(Boolean).join(" ");

  const handleClick = (e) => {
    if (!onClick) return;
    e.stopPropagation();
    onClick(e);
  };

  return (
    <span
      className={className}
      title={label}
      aria-label={label}
      role={onClick ? "button" : undefined}
      onClick={handleClick}
    >
      <svg
        className="record-chain-mark-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path d="M19 5L5 12L19 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="5" cy="12" r="3" fill="currentColor" />
        <circle cx="19" cy="5" r="3" fill="currentColor" />
        <circle cx="19" cy="19" r="3" fill="currentColor" />
      </svg>
      {showLabel ? <span className="record-chain-mark-label">{label}</span> : null}
    </span>
  );
};

export default RecordChainMark;
